import { createReactElement, UpdatableReactElement } from 'shared/utils/react.utils'
import { BaseModalController, IModal, ModalContext } from '../Modal'
import { WarningModal } from 'Components/modal/WarningModal/WarningModal'

export type ViolationsModalMetaData = unknown

export class ViolationsModalController
    extends BaseModalController<ViolationsModalMetaData>
    implements IModal
{
    static Id = 'violations-modal' as const
    constructor(modalContext: ModalContext) {
        super(modalContext, ViolationsModalController.Id)
    }

    createElement(): UpdatableReactElement {
        return createReactElement(WarningModal, {
            getVisibility: this.getVisibility.bind(this),
            closable: false,
            onConfirm: () => {
                this.setVisibility(false)
            },
            onCancel: () => {
                this.setVisibility(false)
            },
            getViolation: this.modalContext.studio.inputManager.getViolation(),
        })
    }
}
